<template>
  <el-dialog title="修改个人信息" :visible.sync="dialogVisible" width="1000px" :before-close="handleClose"
    class="change-info-dialog">
    <div class="dialog-content">
      <el-form ref="form" :model="form" :rules="rules" label-width="140px" class="change-form">
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item label="用户编号：">
              <el-input v-model="form.userCode" disabled size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员类型：">
              <el-input v-model="form.type" disabled size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="用户名：">
              <el-input v-model="form.username" disabled size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：">
              <el-input :value="form.sex === 1 ? '男' : form.sex === 2 ? '女' : ''" disabled size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="姓名：">
              <el-input v-model="form.name" disabled size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型：">
              <el-input v-model="form.zhengJianLeiXing" disabled size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="出生年月：">
              <el-input v-model="form.chuShengNianYue" disabled size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码：">
              <el-input v-model="form.zhengJianHaoMa" disabled size="small"></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <el-form-item label="政治面貌：" prop="zhengZhiMianMao">
              <el-input v-model="form.zhengZhiMianMao" placeholder="请输入政治面貌" clearable size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="民族：" prop="minZu">
              <el-select v-model="form.minZu" placeholder="请选择民族" clearable filterable size="small" style="width: 100%">
                <el-option v-for="nation in nationOptions" :key="nation" :label="nation" :value="nation"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱：" prop="email">
              <el-input v-model="form.email" placeholder="请输入邮箱" clearable size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="移动电话：" prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入移动电话" clearable size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职称：" prop="zhiCheng">
              <el-select v-model="form.zhiCheng" placeholder="请选择职称" clearable size="small" style="width: 100%">
                <el-option value="初级">初级</el-option>
                <el-option value="中级">中级</el-option>
                <el-option value="副高级">副高级</el-option>
                <el-option value="正高级">正高级</el-option>
                <el-option value="其他">其他</el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="职务：" prop="zhiWu">
              <el-input v-model="form.zhiWu" placeholder="请输入职务" clearable size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位名称：" prop="danWeiMingCheng">
              <el-input v-model="form.danWeiMingCheng" placeholder="请输入单位名称" clearable size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="科室：" prop="keShi">
              <el-input v-model="form.keShi" placeholder="请输入科室" clearable size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编：" prop="youBian">
              <el-input v-model="form.youBian" placeholder="请输入邮编" clearable size="small"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="专业：" prop="zhuanYe">
              <el-input v-model="form.zhuanYe" placeholder="请输入专业" clearable size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总会：">
              <el-input v-model="form.zongHui" disabled size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分会：" prop="fenHui">
              <el-checkbox-group v-model="form.checkList" class="checkbox-group">
                <el-row>
                  <el-col v-for="item in fenHuiOptions" :key="item" :span="8" class="checkbox-col">
                    <el-checkbox :label="item" class="checkbox-item">
                      {{ item }}
                    </el-checkbox>
                  </el-col>
                </el-row>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="单位地址：" prop="danWeiDiZhi">
              <el-input v-model="form.danWeiDiZhi" placeholder="请输入单位地址" type="textarea" :rows="2" clearable size="small"
                style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="主要学习经历：" prop="studyLog">
              <el-input v-model="form.studyLog" type="textarea" :rows="3" placeholder="请输入主要学习经历" clearable size="small"
                resize="none" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="主要学术或科普论著、研究成果：" prop="chengGuo">
              <el-input v-model="form.chengGuo" type="textarea" :rows="3" placeholder="请输入主要学术或科普论著、研究成果" clearable
                size="small" resize="none" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" :disabled="submitting" size="small">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting" :disabled="!isFormModified" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changeUserInfo } from "../../http/request";

export default {
  name: "ChangeInfoDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {},
      originalForm: {},
      submitting: false,
      fenHuiOptions: [
        '上海卒中学会青年工作委员会',
        '上海卒中学会神经内科分会',
        '上海卒中学会心血管内科分会',
        '上海卒中学会中西医结合分会',
        '上海卒中学会护理分会',
        '上海卒中学会神经康复分会',
        '上海卒中学会血管内治疗分会',
        '上海卒中学会临床药学分会'
      ],
      nationOptions: [
        '汉族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族',
        '朝鲜族', '满族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族',
        '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族',
        '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族',
        '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '塔吉克族', '怒族', '乌孜别克族',
        '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族',
        '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'
      ],
      rules: {
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }
        ],
        youBian: [
          { pattern: /^\d{6}$/, message: '邮编必须是6位数字', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  computed: {
    // 检查表单是否有修改
    isFormModified() {
      if (Object.keys(this.originalForm).length === 0) return false;

      const modifiedFields = [
        'zhengZhiMianMao', 'minZu', 'email', 'zhiCheng', 'zhiWu',
        'danWeiMingCheng', 'mobile', 'keShi', 'youBian', 'zhuanYe',
        'danWeiDiZhi', 'studyLog', 'chengGuo', 'checkList'
      ];

      return modifiedFields.some(field => {
        if (field === 'checkList') {
          const original = [...this.originalForm[field]].sort();
          const current = [...this.form[field]].sort();
          return JSON.stringify(original) !== JSON.stringify(current);
        }
        return this.originalForm[field] !== this.form[field];
      });
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initForm();
        }
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  methods: {
    // 初始化表单数据
    initForm() {
      const formData = {
        ...this.userInfo,
        checkList: Array.isArray(this.userInfo.fenHui)
          ? this.userInfo.fenHui
          : (this.userInfo.fenHui ? this.userInfo.fenHui.split(',').filter(item => item.trim()) : [])
      };

      this.form = { ...formData };
      this.originalForm = JSON.parse(JSON.stringify(formData));
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    // 关闭弹窗
    handleClose() {
      if (this.isFormModified) {
        this.$confirm('表单有修改，确定要取消吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.doClose();
        }).catch(() => { });
      } else {
        this.doClose();
      }
    },

    doClose() {
      this.dialogVisible = false;
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },

    // 提交表单
    async handleSubmit() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid) return;

        this.submitting = true;

        const submitData = {
          id: this.userInfo.id,
          zhengZhiMianMao: this.form.zhengZhiMianMao,
          minZu: this.form.minZu,
          email: this.form.email,
          zhiCheng: this.form.zhiCheng,
          zhiWu: this.form.zhiWu,
          danWeiMingCheng: this.form.danWeiMingCheng,
          mobile: this.form.mobile,
          keShi: this.form.keShi,
          youBian: this.form.youBian,
          zhuanYe: this.form.zhuanYe,
          danWeiDiZhi: this.form.danWeiDiZhi,
          studyLog: this.form.studyLog,
          chengGuo: this.form.chengGuo,
          fenHui: this.form.checkList.join(',')
        };

        const response = await changeUserInfo(submitData);

        if (response.data.code === 0) {
          this.$message.success('个人信息修改成功');
          this.$emit('update-success');
          this.doClose();
        } else {
          this.$message.error(response.data.msg || '修改失败');
        }
      } catch (error) {
        console.error('修改个人信息失败:', error);
        this.$message.error('修改失败，请重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.change-info-dialog {
  ::v-deep .el-dialog {
    margin-top: 5vh !important;

    .el-dialog__body {
      padding: 20px;
      max-height: 70vh;
      overflow-y: auto;
    }

    .el-dialog__footer {
      padding: 15px 20px;
      border-top: 1px solid #e8e8e8;
    }
  }

  .dialog-content {
    .change-form {
      .el-form-item {
        margin-bottom: 15px;
      }

      .checkbox-group {
        .checkbox-col {
          margin-bottom: 8px;
        }

        .checkbox-item {
          width: 100%;
          margin: 0;

          ::v-deep .el-checkbox__label {
            white-space: normal;
            word-break: break-word;
            line-height: 1.4;
            font-size: 12px;
          }
        }
      }

      .el-input.is-disabled ::v-deep .el-input__inner {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #666;
        cursor: not-allowed;
      }

      .el-textarea.is-disabled ::v-deep .el-textarea__inner {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #666;
        cursor: not-allowed;
      }
    }
  }

  .dialog-footer {
    .el-button {
      min-width: 80px;
      margin-left: 10px;
    }
  }
}
</style>